import axios from "axios";
import { handleRequestError } from "../requests";

export const getCurrencyRates = async () => {
  const results = await axios.get('/Maintenance/GetCurrencyRates').catch(handleRequestError);
  return results.data;
}